module.exports = __webpack_public_path__ + "static/Teacher-Page2-c3cbaf66c93fc19c3774cfdd561b3fbd.jpg";